import { Navigate } from 'react-router-dom';
import LoginPage from '../containers/login';
import AuthLayout from '../layouts/AuthLayout';
import GuestGuard from './guards/guestGuard';
import { ROUTE_PATHS } from './constants';

const AuthRoutes = {
  path: '/',
  element: (
    <GuestGuard>
      <AuthLayout />
    </GuestGuard>
  ),
  children: [
    {
      path: '/',
      element: <LoginPage />,
    },
    {
      path: '*',
      element: <Navigate to={ROUTE_PATHS.LOGIN} replace />,
    },
  ],
};
export default AuthRoutes;
